import React from "react";
import Select, { components } from "react-select";
import OfferList from "../../../components/Recruitment/OfferList";
import Search from "../../../components/Header/Search/Search";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <span className="ico-down text-blue-600"></span>
    </components.DropdownIndicator>
  );
};

const Offer = () => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between px-10 pb-4 mt-8">
        <div>
          <h2>Offer Lists</h2>
          <p>Manage all employe on your organization</p>
        </div>
      </div>
      <div className="flex justify-between items-center px-10 pb-4">
        <div className="flex gap-3">
          <input
            type="date"
            placeholder="Select a date"
            className="appearance-none bg-transparent border border-gray-300 rounded w-32 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-blue-600"
          />

          <Select
            options={[
              { value: "All", label: "All" },
              { value: "India", label: "India" },
              { value: "USA", label: "USA" }
            ]}
            components={{ DropdownIndicator }}
            className="custom-select-container text-gray-500"
            defaultValue={{
              value: "Source: All",
              label: "Source: All"
            }}
          />
          <Select
            options={[
              { value: "All", label: "All" },
              { value: "India", label: "India" },
              { value: "USA", label: "USA" }
            ]}
            components={{ DropdownIndicator }}
            className="custom-select-container text-gray-500"
            defaultValue={{
              value: "Added By: All",
              label: "Added By: All"
            }}
          />
        </div>
        <div className="flex">
          <div>
            <Search />
          </div>
          <a href="" className="btn btn--border text-[14px]">
            <span>
              <i className="ico-download mr-1"></i>
            </span>
            Download
          </a>
        </div>
      </div>
      <OfferList />
    </div>
  );
};

export default Offer;
